// extracted by mini-css-extract-plugin
module.exports = {"main-component":"eventAlertNegative_main-component__2Op3U"};